import length from "rfuncs/functions/length"
import map from "rfuncs/functions/map"
import merge from "rfuncs/functions/merge"
import scan from "rfuncs/functions/scan"

import intervals_to_numbers from "../../actions/utils//intervals_to_numbers"
import range_to_intervals from "../../actions/utils//range_to_intervals"
import get_imposition_data from "../../actions/utils/get_imposition_dispatch_data"
import plot_from_context from "./plot_from_context"
export default async function* plot_imposition_pdf(generator) {
  for await (const [
    url,
    used_pages,
    positions,
    printable,
    layers,
  ] of generator) {
    const context = await get_imposition_data(url)
    const values = []
    scan(
      ({ range, position, rotation }) =>
        scan(
          page =>
            values.push([
              page,
              {
                used_pages,
                layers,
                context: merge(context, {
                  pages: map(n => context.meta.pages[n - 1], page),
                }),
                printable,
                position,
                rotation,
              },
            ]),
          intervals_to_numbers(range_to_intervals(range))
        ),
      positions || [
        {
          range: `1-${length(context.meta.pages)}`,
        },
      ]
    )
    const total = length(values)

    for (const [page, payload] of values)
      for await (const info of plot_from_context(payload))
        yield {
          ...info,
          page,
          total,
        }
  }
}
